import styles from './Or.module.scss';

export const Or = () => (
    <div className={styles.container}>
        <span className={styles.text}>Or</span>
    </div>
);

export default Or;
